import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";
import { toast } from "sonner";

export default function Login() {
  const { login, lang } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/lobby");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/lobby";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="lux-card p-10">
        <h1 className="font-serif text-3xl gold-text text-center mb-2">{t(lang,"auth.signin")}</h1>
        <p className="text-center text-white/40 text-xs mb-8">{t(lang,"auth.welcome_bonus")}</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">{t(lang,"auth.email")}</label>
            <input data-testid="login-email" required type="email" value={email} onChange={e=>setEmail(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 focus:border-[#d4af37] focus:outline-none"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">{t(lang,"auth.password")}</label>
            <input data-testid="login-password" required type="password" value={password} onChange={e=>setPassword(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 focus:border-[#d4af37] focus:outline-none"/>
          </div>
          <button data-testid="login-submit" disabled={loading} className="btn-gold w-full py-3 rounded-md">{loading?"…":t(lang,"auth.signin")}</button>
        </form>
        <div className="my-5 flex items-center gap-3 text-white/30 text-xs"><div className="flex-1 h-px bg-white/10"/>{t(lang,"auth.or")}<div className="flex-1 h-px bg-white/10"/></div>
        <button data-testid="google-login" onClick={onGoogle} className="btn-ghost w-full py-3 rounded-md text-sm">{t(lang,"auth.google")}</button>
        <p className="text-center text-xs text-white/50 mt-6">{t(lang,"auth.no_account")} <Link to="/register" className="text-[#d4af37]">{t(lang,"auth.signup")}</Link></p>
      </div>
    </div>
  );
}
